module.exports = __webpack_public_path__ + "img/is-audit.6b62c099.png";